// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RpYBkDqZGdShL7NHXrBz {
  position: fixed;
  bottom: 20px;
  left: 15px;
  margin-bottom: 0px;
  z-index: 1;
  border-radius: 10px;
}

.AbRM0KGfJv5fN_S8O7uj {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 200px;
  max-height: 80vh;
  height: 260px;
  background: rgb(34, 34, 34);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
}
.AbRM0KGfJv5fN_S8O7uj.rOSrGugcudPyizjOGKlb {
  transition: none;
}
.AbRM0KGfJv5fN_S8O7uj {
  will-change: transform, height;
  z-index: 100;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 12px;
  cursor: ns-resize;
  background: rgb(33, 33, 33);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 101;
}
.AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA::before, .AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 30px;
  height: 2px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 1px;
}
.AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA::before {
  top: 3px;
}
.AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA::after {
  bottom: 3px;
}
.AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA:hover {
  background: rgb(77, 77, 77);
}
.AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA:hover::before, .AbRM0KGfJv5fN_S8O7uj .YE_u2QCCNwbdsfHuQNIA:hover::after {
  background: rgba(255, 255, 255, 0.6);
}
.AbRM0KGfJv5fN_S8O7uj .JMEs8kl7pi288AoMoImT {
  background-color: #774dee;
  padding: 6px 12px;
  border-radius: 8px;
}
.AbRM0KGfJv5fN_S8O7uj.Wph6t_EisUTHFiatFJtD {
  transform: translateY(0);
}

.Ndbf61JBEE_SAtAzrSiy {
  position: absolute;
  display: flex;
  width: 64px;
  height: 40px;
  right: 15px;
  cursor: pointer;
  padding: 4px 20px;
  border-radius: 8px;
  z-index: 2;
}

.uW8aUnASiKH0dCv0HqkQ {
  position: sticky;
  top: 0;
  background: rgb(34, 34, 34);
  padding: 26px 22px 6px 42px;
  z-index: 1;
  display: flex;
  align-items: center;
}
.uW8aUnASiKH0dCv0HqkQ .LVOPDJIXWtwQCitSB8pE {
  width: 100%;
  padding-right: 20px; /* Make space for close button */
}

.EvIig0CDVTR1KxyvAdEr {
  flex: 1;
  overflow-y: auto;
  padding: 0 40px 20px 42px;
}

.RpDv983yPVZWE5F9OPHB {
  display: flex;
  column-gap: 14px;
  flex-wrap: wrap;
  row-gap: 25px;
  padding-top: 12px;
}
.RpDv983yPVZWE5F9OPHB .Z6Kvkx1xg_WOzoRneCFp ._7CKKaH1wzRx0afwskDVG {
  margin-bottom: 15px;
  object-fit: cover;
  width: 206px;
  height: 114px;
}
.RpDv983yPVZWE5F9OPHB .Z6Kvkx1xg_WOzoRneCFp {
  cursor: pointer;
}
.RpDv983yPVZWE5F9OPHB .Vu073V2ryLtGkaUL28mO {
  display: flex;
  align-items: center;
  column-gap: 15px;
}
.RpDv983yPVZWE5F9OPHB .pNymWHVNBFm6SdE4tmCQ {
  color: rgb(182, 182, 182);
  max-width: 182px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/AddLayerPanel/AddLayerPanel.module.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,wCAAA;EACA,2BAAA;EACA,sCAAA;AAAF;AACE;EACE,gBAAA;AACJ;AAdA;EAeE,8BAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAEF;AAAE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,iDAAA;EACA,YAAA;AAEJ;AAAI;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;AACN;AAEI;EACE,QAAA;AAAN;AAGI;EACE,WAAA;AADN;AAII;EACE,2BAAA;AAFN;AAIM;EAEE,oCAAA;AAHR;AAQE;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;AANJ;AASE;EACE,wBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AARF;;AAWA;EACE,gBAAA;EACA,MAAA;EACA,2BAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AARF;AAUE;EACE,WAAA;EACA,mBAAA,EAAA,gCAAA;AARJ;;AAYA;EACE,OAAA;EACA,gBAAA;EACA,yBAAA;AATF;;AAYA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AATF;AAYI;EACE,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAVN;AAKE;EAOE,eAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AAXJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addLayerButton": `RpYBkDqZGdShL7NHXrBz`,
	"panel": `AbRM0KGfJv5fN_S8O7uj`,
	"dragging": `rOSrGugcudPyizjOGKlb`,
	"dragHandle": `YE_u2QCCNwbdsfHuQNIA`,
	"badge": `JMEs8kl7pi288AoMoImT`,
	"open": `Wph6t_EisUTHFiatFJtD`,
	"closeButton": `Ndbf61JBEE_SAtAzrSiy`,
	"header": `uW8aUnASiKH0dCv0HqkQ`,
	"categories": `LVOPDJIXWtwQCitSB8pE`,
	"contentContainer": `EvIig0CDVTR1KxyvAdEr`,
	"cards": `RpDv983yPVZWE5F9OPHB`,
	"card": `Z6Kvkx1xg_WOzoRneCFp`,
	"img": `_7CKKaH1wzRx0afwskDVG`,
	"body": `Vu073V2ryLtGkaUL28mO`,
	"description": `pNymWHVNBFm6SdE4tmCQ`
};
export default ___CSS_LOADER_EXPORT___;
